import { useNavigate } from 'react-router-dom';
import type { ComponentType, SVGProps } from 'react';
import { WidgetCard } from '@/components/common/WidgetCard';
import {
  InboxIcon, GlobeAltIcon, AtSymbolIcon, ArrowsRightLeftIcon, QueueListIcon, DocumentTextIcon,
} from '@/icons';

interface Action {
  label: string;
  to: string;
  icon: ComponentType<SVGProps<SVGSVGElement>>;
}

/**
 * Quick Actions — shortcuts into the API-backed create/manage flows. These are
 * navigation affordances (the destination screens perform the API calls).
 */
export function QuickActionsWidget() {
  const navigate = useNavigate();

  const actions: Action[] = [
    { label: 'New mailbox', to: '/mailboxes?new=1', icon: InboxIcon },
    { label: 'Add domain', to: '/domains?new=1', icon: GlobeAltIcon },
    { label: 'Create alias', to: '/aliases?new=1', icon: AtSymbolIcon },
    { label: 'Add forwarder', to: '/forwarders?new=1', icon: ArrowsRightLeftIcon },
    { label: 'View queue', to: '/queue', icon: QueueListIcon },
    { label: 'Search logs', to: '/logs', icon: DocumentTextIcon },
  ];

  return (
    <WidgetCard title="Quick Actions">
      <div className="grid grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-6">
        {actions.map((a) => {
          const Icon = a.icon;
          return (
            <button
              key={a.to}
              type="button"
              onClick={() => navigate(a.to)}
              className="flex flex-col items-center gap-2 rounded-lg border border-border bg-surface p-3 text-center text-xs font-medium text-fg-muted transition-colors hover:border-brand hover:bg-brand/5 hover:text-brand focus-visible:ring-2 focus-visible:ring-brand"
            >
              <span className="grid h-9 w-9 place-items-center rounded-lg bg-surface-raised text-fg-muted">
                <Icon className="h-5 w-5" aria-hidden="true" />
              </span>
              {a.label}
            </button>
          );
        })}
      </div>
    </WidgetCard>
  );
}
